import { jsx as _jsx } from "react/jsx-runtime";
import { connect } from 'react-redux';
import { useFlag } from '@unleash/proxy-client-react';
import { getDonations } from '~/selectors/donation';
import { featureOn } from '~/utils/featureToggle';
import { Feature } from '~/types/common';
import DonationSummary from './donationSummary';
const DONATION_WIDGET = featureOn(Feature.donation_widget);
const DonationSummarySection = ({ donations }) => {
    const crowdfundingWidgetOn = process.env.NODE_ENV === 'test' ? false : useFlag('crowdfunding-widget');
    if (DONATION_WIDGET || crowdfundingWidgetOn) {
        return (_jsx(DonationSummary, { donations: donations, type: crowdfundingWidgetOn ? 'crowdfunding' : 'charity' }));
    }
    else {
        return null;
    }
};
const mapStateToProps = (state) => ({
    donations: getDonations(state),
});
export default connect(mapStateToProps)(DonationSummarySection);
